import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import TypeSelector from './view.tsx';

export default injectIntl(TypeSelector);
